<template>
  <el-button-group class="apex-table-columns-fixed-controller">
    <el-button
      v-for="option of options"
      :key="option.icon"
      :type="value === option.value ? 'primary' : 'default'"
      :icon="option.icon"
      :title="option.title"
      :disabled="disabledFixed"
      @click="submit(option.value)"
    />
  </el-button-group>
</template>

<script>
import locale from '@/mixins/index'

export default {
  name: 'ApexTableColumnsFixedController',
  mixins: [locale],
  props: {
    value: {
      default: false
    },
    disabledFixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      return [
        {
          value: 'left',
          icon: 'el-icon-arrow-left',
          title: this.t('table.toolbar.leftFixed')
        },
        {
          value: false,
          icon: 'el-icon-close',
          title: this.t('table.toolbar.notFixed')
        },
        {
          value: 'right',
          icon: 'el-icon-arrow-right',
          title: this.t('table.toolbar.rightFixed')
        }
      ]
    }
  },
  methods: {
    submit(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.apex-table-columns-fixed-controller {
  .el-button {
    padding: 2px;
    font-size: 10px;
  }
}
</style>
